<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="900px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add New Payment') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-layout row xs12>
              <v-flex xs4 pa-2 ma-2 green lighten-3 v-show="showBalanceDetail">
                <p class="subheading font-weight-regular mb-0">
                  {{ $t('Total Debit') }}:
                  <strong>{{ account.total_debit | currency }} {{ systemCurrency }}</strong>
                </p>
              </v-flex>

              <v-flex xs4 pa-2 ma-2 red lighten-3 @click="showBalanceDetail = !showBalanceDetail">
                <p class="subheading font-weight-regular mb-0">
                  {{ $t('Total Balance') }}:
                  <strong>{{ account.total_balance | currency }} {{ systemCurrency }}</strong>
                </p>
              </v-flex>

              <v-flex xs4 pa-2 ma-2 yellow lighten-3 v-show="showBalanceDetail">
                <p class="subheading font-weight-regular mb-0">
                  {{ $t('Total Credit') }}:
                  <strong>{{ account.total_credit | currency }} {{ systemCurrency }}</strong>
                </p>
              </v-flex>
            </v-layout>

            <v-flex xs12 pt-4 text-xs-center>
              <h3>{{ account.vender_name }}</h3>
            </v-flex>
            <v-flex xs12 pb-4 pt-2 mr-5 ml-5>
              <v-divider />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                id="payable-payment-focus-me"
                v-model="form.name"
                :label="`${$t('Recipient Name')} *`"
                name="recipient_name"
                box
                hide-details
                background-color="white"
                :error="errors.has('recipient_name')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs3 pa-2>
              <v-autocomplete
                v-model="form.payment_type"
                :label="`${$t('Payment Type')} *`"
                hide-details
                :items="paymentTypes"
                box
                data-vv-name="Payment Type"
                background-color="white"
                :error="errors.has('Payment Type')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs3 class="pa-2">
              <v-menu v-model="dateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  v-model="form.date"
                  :label="`${$t('Payment Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="payment_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('payment_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="dateMenu = false" v-model="form.date" />
              </v-menu>
            </v-flex>

            <v-flex xs6 pa-2 v-if="form.payment_type === 'Remittance'">
              <v-autocomplete
                v-model="form.remittance_office_id_fk"
                :label="`${$t('Remittance Office')} *`"
                hide-details
                :items="remittances"
                box
                data-vv-name="Remittance Office"
                background-color="white"
                :error="errors.has('Remittance Office')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs6 pa-2 v-if="form.payment_type === 'Remittance'">
              <v-text-field
                v-model.number="form.remittance_commission"
                :label="`${$t('Remittance Commission')} (${systemCurrency}) *`"
                name="remittance_commission"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                data-vv-delay="1000"
                :error="errors.has('remittance_commission')"
                v-validate="'required|decimal|min_value:0'"
              />
            </v-flex>

            <v-flex xs5 class="pa-2">
              <v-text-field
                v-model.number="form.amount"
                :label="`${$t('Amount')} (${systemCurrency}) *`"
                name="amount"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                :error="errors.has('amount')"
                v-validate="'required|decimal|min_value:1'"
              />
            </v-flex>

            <v-flex xs2 class="pa-2">
              <v-text-field
                v-model.number="form.discount"
                :label="`${$t('Discount')} (${systemCurrency})`"
                name="discount"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                v-validate="'decimal|min_value:0'"
              />
            </v-flex>

            <v-flex xs5 class="pa-2">
              <v-text-field
                :value="netAmount"
                :label="`${$t('Net Amount')} (${systemCurrency})`"
                name="net_amount"
                box
                hide-details
                readonly
                background-color="white"
                autocomplete="off"
                v-validate="'decimal|min_value:0'"
              />
            </v-flex>

            <v-flex xs12 class="pa-2">
              <v-textarea
                v-model="form.note"
                :label="$t('Note')"
                name="payment_note"
                box
                hide-details
                height="80"
                background-color="white"
              />
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true },
    account: { type: Object, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnAddLoading: false,
      dateMenu: false,
      form: {
        name: '',
        date: '',
        payment_type: '',
        remittance_office_id_fk: null,
        remittance_commission: null,
        amount: null,
        discount: null,
        note: ''
      },
      keepForm: false,
      showBalanceDetail: false
    }
  },

  computed: {
    ...mapGetters({
      paymentTypes: 'accountPayable/getPaymentTypes',
      remittances: 'remittances/getFullRemittanceOfficesList'
    }),
    netAmount() {
      const netAmount = this.form.amount - this.form.discount
      return isNaN(netAmount) ? 0 : netAmount
    }
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addPayment: 'accountPayments/addPayment'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.date = this.$moment()
        .format()
        .substr(0, 10)
      this.form.discount = 0
      this.form.payment_type = 'Cash'
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('payable-payment-focus-me').focus()
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            let formData = new FormData(event.target)
            formData.append('account_payable_id_fk', this.account.account_payable_id)
            formData.append('cash_remittance_bank', this.form.payment_type)
            formData.append('remittance_office_id_fk', this.form.remittance_office_id_fk || '')

            // for (let pair of formData.entries()) {
            //   console.warn(`${pair[0]}: ${pair[1]}`)
            // }

            this.addPayment(formData)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped />
